export function postMessageParent(msg: string | Record<string, any>): void {
  // TODO (S.Panfilov) what is domain? should be that domain or "window.location.origin"
  window.parent.postMessage(msg, window.location.origin);
}
